import angular from "angular";
import {
  MultipleMachineChangeChildStateServiceProvider,
  vsMultiServiceName as MultipleMachineChangeChildStateServiceName,
  MachineChangeMultipleComponentOptions,
  vsMultiComponentName as MachineChangeMultipleComponentName,
  SingleMachineChangeChildStateServiceProvider,
  vsSingleServiceName as SingleMachineChangeChildStateServiceName,
  MachineChangeSingleComponentOptions,
  vsSingleComponentName as MachineChangeSingleComponentName,
} from "./components/machineChange";
import {
  machineDetailsTabsComponentOptions,
  MachineDetailTabsProvider,
  vsName as machineDetailsTabsComponentOptionsName,
  vsServiceName as machineDetailTabsServiceName,
} from "./components/views/machines/detail/tabs";
import {
  conversionModalComponentOptions,
  ConversionModalService,
  vsName as conversionModalComponentOptionsName,
  vsServiceName as conversionModalServiceName,
} from "./components/conversionModal";
import {
  machineDetailComponentOptions,
  vsComponentName as MachineDetailComponentName,
} from "./components/views/machines/detail/component";
import {
  machineDetailConfigurationViewDirective,
  vsComponentName as machineDetailConfigurationViewComponentName,
} from "./components/views/machines/detail/views/configurations";
import {
  MachinesChangeViewComponentOptions,
  MachinesChangeViewModalService,
  vsComponentName as MachinesChangeViewComponentName,
  vsServiceName as MachinesChangeViewModalServiceName,
} from "./components/changeDetailsModel";

import { vsName as reportingModuleName } from "../../reporting";
import {
  machineConfigurationViewComponentOptions,
  vsComponentName as machineConfigurationViewComponentName,
} from "./components/machineConfigurationView";
import { configSelectMachineFormlyType } from "./ui-formly/types/selectMachine/config";
import { configureLookupManagement } from "../../records/lookup/lookupManagement/config";
import {
  vsLookupManagementServiceName as machineLookupManagementServiceName,
  vsLookupManagementServiceProviderName as machineLookupManagementServiceProviderName,
} from "./lookups";
import {
  MachineConfigurationCellClassServiceProvider,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "./machineConfigurationCellClassService";

import { vsModuleName as selectRecordModalModule } from "../../records/services/selectRecordModal";
import {
  MachineConfigurableGridFormViewService,
  vsServiceName as MachineConfigurableGridToggleButtonServiceName,
} from "./utils/configurableRecordView";

import { vsModuleName as changeJournalModule } from "../../records/changeJournal/module";

export const vsModuleName = "SlotTrak.Machines.Shared";

const module = angular
  .module(vsModuleName, [
    reportingModuleName,
    selectRecordModalModule,
    changeJournalModule,
  ])
  .provider(
    MultipleMachineChangeChildStateServiceName,
    MultipleMachineChangeChildStateServiceProvider
  )
  .provider(machineDetailTabsServiceName, MachineDetailTabsProvider)
  .provider(
    SingleMachineChangeChildStateServiceName,
    SingleMachineChangeChildStateServiceProvider
  )
  .component(MachineDetailComponentName, machineDetailComponentOptions)
  .component(
    machineDetailsTabsComponentOptionsName,
    machineDetailsTabsComponentOptions
  )
  .component(
    conversionModalComponentOptionsName,
    conversionModalComponentOptions
  )
  .component(
    MachineChangeMultipleComponentName,
    MachineChangeMultipleComponentOptions
  )
  .component(
    MachineChangeSingleComponentName,
    MachineChangeSingleComponentOptions
  )
  .directive(
    machineDetailConfigurationViewComponentName,
    machineDetailConfigurationViewDirective
  )
  .service(conversionModalServiceName, ConversionModalService)
  .service(MachinesChangeViewModalServiceName, MachinesChangeViewModalService)
  .component(
    MachinesChangeViewComponentName,
    MachinesChangeViewComponentOptions
  )
  .component(
    machineConfigurationViewComponentName,
    machineConfigurationViewComponentOptions
  )
  .config(configSelectMachineFormlyType)
  .provider(
    MachineConfigurationCellClassServiceName,
    MachineConfigurationCellClassServiceProvider
  )
  .service(
    MachineConfigurableGridToggleButtonServiceName,
    MachineConfigurableGridFormViewService
  );

configureLookupManagement(module, {
  baseStateSref: "main.machines.lookups",
  lookupManagementServiceName: machineLookupManagementServiceName,
  lookupManagementServiceProviderName:
    machineLookupManagementServiceProviderName,
  defaultModifyPermission: "machineLookupModify",
});
